import $ from 'jquery';
import rimg from '@pixelunion/rimg-shopify';
import ProductMenu from './ProductMenu';
import ProductDetails from './ProductDetails';
import Layout from '../Layout';
import ScrollLock from '../utils/ScrollLock';

export default class ProductQuickshop {
  constructor($parent, $el, postMessage) {
    // Quickshop isn't a section, but we need this section-like object for ProductDetails functionality
    this.mockSection = {
      postMessage,
      el: $el[0],
    };
    this.$parent = $parent;
    this.$el = $el;
    this.postMessage = postMessage;
    this.$details = $('[data-product-details]', this.$el);
    this.$description = this.$el.find('[data-product-description]');
    this.$featuredImage = $('[data-product-image-featured]', this.$el);
    this.$imageThumbs = $('[data-product-image-thumb]', this.$el);
    this.$imageThumbsSlide = $('[data-product-quickshop-image-thumbnails-slide]', this.$el);
    this.loaded = false;
    try {
      this.data = JSON.parse($('[data-quickshop-data]', this.$el).text());
      this.mockSection.data = this.data;
      this.formIsInline = this.data.form_is_inline;
    } catch(error) {
      console.warn(`Quickshop: invalid quickshop data found. ${error.message}`);
      return;
    }

    this._bindEvents();
  }

  _init() {
    this.$parent.append(this.$el);

    this.productDetails = new ProductDetails(this.$el, this.mockSection, true);

    if (!this.formIsInline) {
      this.productMenu = new ProductMenu(this.$el[0].querySelector('[data-product-menu]'), this.data, this.postMessage, true);
    }

    if (window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }

    rimg.watch(this.$el[0]);

    this.loaded = true;
  }

  _bindEvents() {
    $('[data-product-item-image]', this.$parent).on('click.product-quickshop', (event) => {
      // Minimum height is 500 pixels and must be desktop
      if (!Layout.isBreakpoint('L') || window.innerHeight < 500) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      this._open();
    });

    $('[data-quickshop-container]', this.$el).on('click.product-quickshop', (event) => {
      event.stopPropagation();
    });
  }

  _unbindEvents() {
    $('[data-product-item-image]', this.$parent).off('click.product-quickshop');
    $('[data-quickshop-container]', this.$el).off('click.product-quickshop');
  }

  _bindOnOpen() {
    $('[data-product-quickshop-button-dismiss]', this.$el).on('click.product-quickshop', () => {
      this._close();
    });

    this.$el.on('click.product-quickshop', () => {
      this._close();
    });

    $(document).on('keyup.product-quickshop', (event) => {
      if (event.keyCode == 27) {
        this._close();
      }
    });

    this.productDetails.listenForVariantChange();

    $(window).on('resize.product-quickshop', () => {
      // If the resize was trigger by a fullscreen, do not do anything
      if (document.fullscreenElement) {
        return;
      }

      // Minimum height is 500 pixels and must be desktop
      if (Layout.isBreakpoint('L') && window.innerHeight >= 500) {
        return;
      }

      this._close();
    });
  }

  _unbindOnOpen() {
    $('[data-product-quickshop-button-dismiss]', this.$el).off('click.product-quickshop');
    this.$el.off('click.product-quickshop');
    $(document).off('keyup.product-quickshop');
    this.productDetails.stopListeningForVariantChange();
  }

  _open() {
    if (!this.loaded) {
      this._init();
    }

    this._bindOnOpen();
    this.$el.revealer('show');
    ScrollLock.lock();
  }

  _close() {
    this.productDetails.gallery.pauseModels();
    this.productDetails.gallery.pauseVideos();
    this._unbindOnOpen();
    this.$el.revealer('hide');
    if (this.productMenu) {
      this.productMenu.closeATCSuccess();
    }
    ScrollLock.unlock();
  }

  onSectionMessage(name, data) {
    if (this.productMenu) {
      this.productMenu.onSectionMessage(name, data);
    }

    if (name === 'header-minicart:set-open' && this.loaded) {
      this._close();
    }
  }

  unload() {
    if (this.productMenu) {
      this.productMenu.unload();
    }

    this._unbindOnOpen();
    this._unbindEvents();
  }
}
